import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  ...theme.paddings(10, 20),
  gap: 20,
  width: "100%",
  backgroundColor: theme.palette.white,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.fly.brandBorder}`,

  [theme.down("sm")]: {
    ...theme.paddings(10),
  },
}));
